import styled from 'styled-components';

export const CardContainer = styled.div`
  box-sizing: border-box;
  width: 260px;
  height: 450px;
  border-radius: 10px;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 0.2s;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  &:hover {
    transition: 0.2s;
    box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.25);
  }
`;

export const Title = styled.h3`
  font-weight: normal;
  margin: 10px;
`;
export const ImageContainer = styled.div`
  width: 90%;
  max-height: 50%;
  border-radius: 20px;
  border: 1px solid rgba(219, 219, 219, 1);
  display: flex;
  justify-content: center;
  overflow: hidden;
  background-color: 'white';
`;
export const Image = styled.img`
  height: 100%;
  object-fit: contain;
`;

export const CardContent = styled.div`
  margin: 5px 0;
  box-sizing: border-box;
  word-wrap: break-word;
  padding: 5px 0;
  width: 100%;
  height: 30%;
  overflow: hidden;
  font-size: 0.8rem;
  position: relative;
`;

export const TextContent = styled.p`
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background: linear-gradient(transparent 10%, white);
  }
`;

export const CardText = styled.p`
  margin: 0;
  font-size: 0.8rem;
`;
